<script>
import {
	deleteBooking,
	updateBookingStatusToConfirm,
	updateBooking,
	getInvoiceNumber,
	checkUpdateBookingAvailability,
} from "../../../api/services/booking.service";
import { getPackages } from "../../../api/services/package.service";
import {
	getSubPackageByPackageId,
	getSubPackageById,
} from "../../../api/services/sub-package.service";
import { getAddOnById } from "../../../api/services/addon.service";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import { required, email } from "vuelidate/lib/validators";

export default {
	props: {
		visible: Boolean,
		closeable: Boolean,
		booking: Object,
	},
	components: {
		DatePicker,
		Multiselect,
	},
	data() {
		return {
			submitted: false,
			bookingId: null,
			bookingTitle: null,
			type: null,
			status: null,
			reserverName: null,
			reserverEmail: null,
			reserverTelephone: null,
			numOfPacks: null,
			selectedPackage: null,
			subPackageTitle: null,
			selectedSubPackage: null,
			selectedSubPackagePrice: null,
			extras: [],
			selectedExtras: [],
			totalPrice: null,
			startTime: null,
			endTime: null,
			duration: null,
			bookingDate: null,
			bookingInvoiceNo: null,
			bookingStartDateObject: null,
			bookingEndDateObject: null,
			bookingTime: null,
			bookingNote: null,
			bookingValid: false,
			bookingPassed: false,
			bookingPackages: [],
			bookingSubPackages: [],
			paymentMethod: null,
			editBookingFailed: false,
			showAlert: false,
			editBookingSuccess: false,
			confirmBookingSuccess: false,
			deleteBookingSuccess: false,
			deleteBookingFailed: false,
			showSlots: false,
			suggestedSlots: null,
			responseMessage: null,
			responseVariant: null,
			responseIcon: null,
			isLoading: true,
			checkAvailableTimes: false,
			paymentId: null,
		};
	},
	validations: {
		reserverName: { required },
		reserverEmail: { required, email },
		reserverTelephone: { required },
		numOfPacks: { required },
		bookingDate: { required },
		bookingTime: { required },
	},
	computed: {
		showModal: {
			get() {
				return this.visible;
			},
			set(value) {
				if (!value) {
					this.$emit("close");
				}
			},
		},
	},
	mounted() {
		this.getAllPackages();
		this.handleExtras();
		this.handleInitialPackage();
		this.handleInitialBookingTime();
		if (this.booking) {
			this.bookingId = this.booking.bookingId;
			this.bookingTitle = this.booking.bookingTitle;
			this.type = this.booking.type;
			this.totalPrice = this.booking.totalPrice;
			this.status = this.booking.status;
			this.reserverName = this.booking.reserverName;
			this.reserverEmail = this.booking.reserverEmail;
			this.reserverTelephone = this.booking.reserverTelephone;
			this.numOfPacks = this.booking.numOfPacks;
			this.subPackageTitle = this.booking.subPackage.title;
			this.duration = this.booking.subPackage.duration;
			this.totalPrice = this.booking.totalPrice;
			this.bookingValid = this.booking.bookingValid;
			this.bookingNote = this.booking.bookingNote;
			this.bookingPassed = this.booking.bookingPassed;
			this.paymentMethod = this.booking.paymentMethod;
			this.paymentId = this.booking.paymentId;
		}
		this.getInvoiceNo();
	},
	methods: {
		clickCloseButton() {
			this.$emit("close");
		},
		async clickDeleteBookingButton() {
			this.$refs["del-modal"].hide();
			let deleteServiceBookingSuccess = await deleteBooking(this.bookingId);
			if (deleteServiceBookingSuccess) {
				this.showAlert = true;
				this.responseMessage = this.$i18n.t(
					"booking.editBooking.bookingDeleteSuccess"
				);
				this.responseVariant = "success";
				this.responseIcon = "mdi mdi-check-all mr-2";
				//scrolls the modal to top so that the alert can be seen
				this.$refs[`${this.id}-modal`].$refs.body.scrollTop = 0;
				setTimeout(() => {
					this.$emit("reload");
				}, 2000);
			} else {
				this.showAlert = true;
				this.$i18n.t("booking.editBooking.bookingDeleteSuccess");
				this.responseVariant = "danger";
				this.responseIcon = "bx bx-error-circle mr-2";
				//scrolls the modal to top so that the alert can be seen
				this.$refs[`${this.id}-modal`].$refs.body.scrollTop = 0;
			}
		},
		async clickConfirmBookingButton() {
			let bookingChangeToConfirmSuccess = await updateBookingStatusToConfirm(
				this.bookingId
			);

			if (bookingChangeToConfirmSuccess) {
				this.showAlert = true;
				this.responseMessage = "Booking edited successfully!";
				this.responseVariant = "success";
				this.responseIcon = "mdi mdi-check-all mr-2";
				setTimeout(() => {
					this.$emit("reload");
				}, 3000);
			} else {
				this.showAlert = true;
				this.responseMessage = this.$i18n.t(
					"booking.editBooking.bookingEditFailed"
				);
				this.responseVariant = "danger";
				this.responseIcon = "bx bx-error-circle mr-2";
			}
		},
		//calculates end time when start time or date is changed
		calcEndTime() {
			//new date object created from selected date string
			let date = new Date(this.bookingDate);
			//date is extracted by slicing the string date
			let split_date = date.toString().slice(0, 15);
			//correct date is created by adding selected time to selected date
			let full_date = split_date.concat(" ").concat(this.bookingTime);
			//date object created using selected date and time
			let start_date = new Date(full_date);
			let end_date = new Date(full_date);
			//end date is calculated using duration
			end_date = end_date.setMinutes(end_date.getMinutes() + this.duration);
			end_date = new Date(end_date);
			//sets date objects for sending with the API call
			this.bookingStartDateObject = start_date.toISOString();
			this.bookingEndDateObject = end_date.toISOString();
			//sets date format for displaying end time
			this.endTime = end_date.toString().slice(4, 21);
			if (this.startTime != date) {
				this.checkAvailableTimes = true;
			}
		},
		//method to check booking time availability
		async checkBookingAvailability() {
			this.submitted = true;
			this.$v.$touch();
			if (!this.$v.$invalid) {
				//check availability of edited start and end times
				if (this.checkAvailableTimes === true) {
					let res = await checkUpdateBookingAvailability(
						this.bookingStartDateObject,
						this.bookingEndDateObject,
						this.bookingId
					);
					//if not available, suggested time slots will be displayed
					if (res.isAvailable === false) {
						this.showAlert = true;
						this.showSlots = true;
						this.responseMessage = this.$i18n.t(
							"booking.editBooking.bookingTimeNotAvailable"
						);
						this.responseVariant = "warning";
						this.responseIcon = "bx bx-error-circle mr-2";
						//scrolls the modal to top so that the alert can be seen
						this.$refs[`${this.id}-modal`].$refs.body.scrollTop = 0;
						if (res.alternatives) {
							let altTimes = [];
							for (let date in res.alternatives) {
								let converted_time = new Date(res.alternatives[date].date);
								converted_time = converted_time.toString().slice(0, 21);
								altTimes.push(converted_time);
							}
							this.suggestedSlots = altTimes;
						}
					} else {
						this.updateBooking();
					}
				} else {
					this.updateBooking();
				}
			}
		},
		//method to update booking
		async updateBooking() {
			//create selected extras id array
			let extraIdArray = [];
			if (this.selectedExtras.length > 0) {
				for (let extraId in this.selectedExtras) {
					extraIdArray.push(this.selectedExtras[extraId].value);
				}
			}
			//the updated booking object will be created and sent to the API call
			let bookingObject = {
				id: this.bookingId,
				subPackage: this.selectedSubPackage,
				numOfPacks: parseInt(this.numOfPacks),
				startTime: this.bookingStartDateObject.toString(),
				endTime: this.bookingEndDateObject.toString(),
				totalPrice: this.totalPrice,
				extras: extraIdArray,
				reserverName: this.reserverName,
				reserverEmail: this.reserverEmail,
				reserverTelephone: this.reserverTelephone,
				type: this.type,
				note: this.bookingNote,
			};
			let response = await updateBooking(bookingObject);
			if (response.id) {
				this.showAlert = true;
				this.responseMessage = this.$i18n.t(
					"booking.editBooking.bookingEditSuccess"
				);
				this.responseVariant = "success";
				this.responseIcon = "mdi mdi-check-all mr-2";
				//scrolls the modal to top so that the alert can be seen
				this.$refs[`${this.id}-modal`].$refs.body.scrollTop = 0;
				setTimeout(() => {
					this.$emit("reload");
				}, 3000);
			} else {
				this.showAlert = true;
				this.responseMessage = this.$i18n.t(
					"booking.editBooking.bookingEditFailed"
				);
				this.responseVariant = "danger";
				this.responseIcon = "bx bx-error-circle mr-2";
				//scrolls the modal to top so that the alert can be seen
				this.$refs[`${this.id}-modal`].$refs.body.scrollTop = 0;
			}
		},
		handleAltTimeSelect(item) {
			let date = new Date(item);
			let day = ("0" + date.getDate()).slice(-2);
			let month = date.getMonth() + 1;
			month = ("0" + month).slice(-2);
			let year = date.getFullYear();
			let converted_date = date.toISOString();
			this.bookingDate = year
				.toString()
				.concat("-")
				.concat(month.toString())
				.concat("-")
				.concat(day.toString());
			this.bookingTime = date.toString().slice(16, 21);
			this.bookingStartDateObject = converted_date;
			this.calcEndTime();
		},
		//retreives all the packages for the package dropdown
		async getAllPackages() {
			let packages = await getPackages();
			//loops through the package array and creates a new array of package titles
			for (let packageItem in packages) {
				this.bookingPackages.push({
					value: packages[packageItem].id,
					text: packages[packageItem].title,
				});
			}
		},
		//retrieves all extras for extras dropdown
		// async getAllExtras() {
		//   let extras = await getAddOns();
		//   let allExtras = [];
		//   for(let packageExtra in extras) {
		//     allExtras.push({
		//       value : extras[packageExtra].id,
		//       text : extras[packageExtra].title
		//     });
		//   }
		//   this.extras = allExtras;
		// },
		//gets the extras object array and modifies the array to be displayed in multiselect
		handleExtras() {
			this.extras = this.booking.extras;
			let extrasArray = [];
			for (let extraItem in this.extras) {
				extrasArray.push({
					value: this.extras[extraItem].id,
					text: this.extras[extraItem].title,
				});
			}
			this.selectedExtras = extrasArray;
		},
		//retrieves the new sub packages according to the selected package
		async handlePackageSelect(selectedPackage) {
			this.bookingSubPackages = [];
			let subPackages = await getSubPackageByPackageId(selectedPackage);
			//loops through the sub packages array and creates a new array of sub package titles
			for (let subPackageItem in subPackages) {
				this.bookingSubPackages.push({
					value: subPackages[subPackageItem].id,
					text: subPackages[subPackageItem].title,
				});
			}
			//initially the first sub package is selected by default
			this.selectedSubPackage = this.bookingSubPackages[0].value;
			this.handleSubPackageSelect(this.selectedSubPackage);
		},
		//displays initially selected package of booking
		async handleInitialPackage() {
			this.selectedPackage = this.booking.subPackage.package.id;
			let subPackages = await getSubPackageByPackageId(this.selectedPackage);
			//loops through the sub packages array and creates a new array of sub package titles
			for (let subPackageItem in subPackages) {
				this.bookingSubPackages.push({
					value: subPackages[subPackageItem].id,
					text: subPackages[subPackageItem].title,
				});
			}
			this.handleInitialSubPackage();
		},
		//displays initially selected sub package of booking
		async handleInitialSubPackage() {
			this.selectedSubPackage = this.booking.subPackage.id;
			this.selectedSubPackagePrice = this.booking.subPackage.price;
			let subPackage = await getSubPackageById(this.selectedSubPackage);
			let allExtras = [];
			for (let packageExtra in subPackage.addOns) {
				allExtras.push({
					value: subPackage.addOns[packageExtra].id,
					text: subPackage.addOns[packageExtra].title,
				});
			}
			this.extras = allExtras;
			this.calcTotPrice(this.selectedSubPackagePrice);
		},
		//changes tot price and duration according to sub-package change
		async handleSubPackageSelect(selectedSubPackage) {
			let subPackage = await getSubPackageById(selectedSubPackage);
			this.extras = null;
			let allExtras = [];
			for (let packageExtra in subPackage.addOns) {
				allExtras.push({
					value: subPackage.addOns[packageExtra].id,
					text: subPackage.addOns[packageExtra].title,
				});
			}
			this.extras = allExtras;
			this.selectedExtras = [];
			this.selectedSubPackage = selectedSubPackage;
			this.duration = subPackage.duration;
			this.selectedSubPackagePrice = subPackage.price;
			this.calcEndTime();
			this.calcTotPrice(this.selectedSubPackagePrice);
		},
		//modifies start and end times to be displayed
		handleInitialBookingTime() {
			let date = null;
			let month = null;
			let year = null;
			//new date object is created for start time
			this.startTime = new Date(this.booking.startTime);
			//the date is formatted so that date is a two digit string
			date = ("0" + this.startTime.getDate()).slice(-2);
			//month is increased by 1 and formatted to be a two digit string
			month = this.startTime.getMonth() + 1;
			month = ("0" + month).slice(-2);
			//year does not need to be formatted
			year = this.startTime.getFullYear();
			//booking date is formed by joining the above variables
			this.bookingDate = year
				.toString()
				.concat("-")
				.concat(month.toString())
				.concat("-")
				.concat(date.toString());
			this.bookingTime = this.startTime.toString().slice(16, 21);
			this.bookingStartDateObject = this.booking.startTime;
			//new date object for end time is created
			this.endTime = new Date(this.booking.endTime);
			this.endTime = this.endTime.toString().slice(4, 21);
			this.bookingEndDateObject = this.booking.endTime;
		},
		//calculate booking total price
		async calcTotPrice(subPackagePrice) {
			let totPriceAddOns = 0;
			if (this.selectedExtras.length > 0) {
				for (let addOn in this.selectedExtras) {
					let addOnId = this.selectedExtras[addOn].value;
					let addOnItem = await getAddOnById(addOnId);
					if (addOnItem.pricingType === "ENTIRE") {
						totPriceAddOns = totPriceAddOns + addOnItem.price;
					} else {
						totPriceAddOns = totPriceAddOns + addOnItem.price * this.numOfPacks;
					}
				}
			}
			this.totalPrice = subPackagePrice + totPriceAddOns;
			this.isLoading = false;
		},
		//changes tot price according to changed fields
		handleTotPriceChange() {
			this.calcTotPrice(this.selectedSubPackagePrice);
		},
		//retreives the invoice number for the booking being edited
		async getInvoiceNo() {
			this.bookingInvoiceNo = await getInvoiceNumber(this.bookingId);
		},
	},
};
</script>

<template>
	<!-- Edit Event Model Model -->
	<b-modal
		:id="id"
		:ref="`${id}-modal`"
		v-model="showModal"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		no-close-on-esc
		header-close-content
		scrollable
		size="xl"
	>
		<div>
			<div v-if="isLoading">
				<div class="col-12 text-center p-5">
					<b-spinner
						style="width: 5rem; height: 5rem"
						class="m-2"
						variant="mid"
						role="status"
					></b-spinner>
				</div>
			</div>
			<div v-else>
				<form @submit.prevent="checkBookingAvailability">
					<div class="row mt-3 justify-content-center">
						<div class="col-md-12 mb-3">
							<h5>{{ $t("booking.editBooking.title") }}</h5>
						</div>
						<!-- Edit Sucees and Failed Msg -->
						<div class="col-md-12 mb-3">
							<b-alert
								v-model="showAlert"
								:variant="this.responseVariant"
								dismissible
								><em :class="this.responseIcon"></em
								>{{ responseMessage }}</b-alert
							>
						</div>
						<!-- booking title -->
						<div class="col-md-12">
							<label class="mr-4">
								<em
									class="bx bx-notification font-size-16 align-middle mr-1"
								></em
								>{{ $t("booking.editBooking.bookingTitle") }}:
							</label>
							{{ this.bookingTitle }} {{ this.subPackageTitle }}
						</div>
						<!-- booking Date -->
						<div class="col-md-4 mt-3">
							<label class="mr-5">
								<em
									class="bx bx-calendar-alt font-size-16 align-middle mr-1"
								></em>
								{{ $t("booking.editBooking.bookinDate") }}:
							</label>
							<date-picker
								class="col-md-5"
								:class="{ 'is-invalid': submitted && $v.bookingDate.$error }"
								v-model="bookingDate"
								value-type="format"
								type="date"
								placeholder="yyyy:mm:dd"
								@input="calcEndTime()"
							></date-picker>
							<div
								v-if="submitted && $v.bookingDate.$error"
								class="invalid-feedback"
							>
								<span v-if="!$v.bookingDate.required">{{
									$t("booking.editBooking.inputValidationMessage")
								}}</span>
							</div>
						</div>
						<!-- booking Starting Time -->
						<div class="col-md-4 mt-3">
							<label class="mr-3">
								<em class="bx bx-time font-size-16 align-middle mr-1"></em>
								{{ $t("booking.editBooking.bookingStratingTime") }}:
							</label>
							<date-picker
								class="col-md-4"
								:class="{ 'is-invalid': submitted && $v.bookingTime.$error }"
								v-model="bookingTime"
								format="HH:mm"
								value-type="format"
								type="time"
								placeholder="hh:mm"
								@input="calcEndTime()"
							></date-picker>
							<div
								v-if="submitted && $v.bookingTime.$error"
								class="invalid-feedback"
							>
								<span v-if="!$v.bookingTime.required">{{
									$t("booking.editBooking.inputValidationMessage")
								}}</span>
							</div>
						</div>
						<!-- booking Ending Time -->
						<div class="col-md-4 mt-4">
							<label class="mr-3">
								<em class="bx bx-time-five font-size-16 align-middle mr-1"></em>
								{{ $t("booking.editBooking.bookingEndingTime") }}:
							</label>
							{{ this.endTime }}
						</div>
						<!-- Suggested Slots -->
						<div class="col-md-12 mt-4" v-if="showSlots">
							<label class="mr-4">
								<em
									class="bx bx-calendar-alt font-size-16 align-middle mr-1"
								></em>
								{{ $t("booking.editBooking.suggestedSlots") }}:
							</label>
							<b-button
								variant="outline-success"
								class="mr-2 mt-1"
								v-for="item in suggestedSlots"
								:key="item"
								@click="handleAltTimeSelect(item)"
							>
								{{ item }}</b-button
							>
						</div>
						<div class="col-md-12 border-top mt-4"></div>
						<!-- booking Status -->
						<div class="col-md-4 mt-4">
							<label class="mr-5">
								<em class="bx bx-food-tag font-size-16 align-middle mr-1"></em
								>{{ $t("booking.editBooking.bookingStatus") }}:
							</label>
							<b-badge
								v-if="this.status === 'PENDING'"
								class="ml-3 font-size-12"
								variant="warning"
							>
								{{ $t("booking.bookingTypes.pending") }}
							</b-badge>
							<b-badge
								v-if="this.status === 'CONFIRMED'"
								class="ml-3 font-size-12"
								variant="success"
							>
								{{ $t("booking.bookingTypes.confirmed") }}
							</b-badge>
							<b-badge
								v-if="this.status === 'REJECTED'"
								class="ml-3 font-size-12"
								variant="danger"
							>
								{{ $t("booking.bookingTypes.rejected") }}
							</b-badge>
							<b-badge
								v-if="this.status === 'CANCELLED'"
								class="ml-3 font-size-12"
								variant="danger"
							>
								{{ $t("booking.bookingTypes.rejected") }}
							</b-badge>
						</div>
						<!-- Booking Payment Method -->
						<div class="col-md-2 mt-4">
							<label class="mr-1">
								<em class="bx bx-money font-size-16 align-middle mr-1"></em
								>{{ $t("booking.editBooking.bookingPaymethod") }}:
							</label>
						</div>
						<div class="col-md-2 mt-4">
							<div v-if="this.paymentMethod === 'card'">Karte</div>
							<div v-else-if="this.paymentMethod === 'sepa_debit'">SEPA</div>
							<div v-else>Andere</div>
						</div>
						<!-- Booking Payment Id -->
						<div class="col-md-4 mt-4" v-if="this.paymentId !== null">
							<label class="mr-3">
								<em
									class="bx bx-credit-card font-size-16 align-middle mr-1"
								></em>
								{{ $t("booking.editBooking.bookingPaymentId") }}:
							</label>
							<strong>{{ this.paymentId }}</strong>
						</div>
						<div class="col-md-4 mt-4" v-else>
							<label class="mr-3">
								<em
									class="bx bx-credit-card font-size-16 align-middle mr-1"
								></em>
								{{ $t("booking.editBooking.bookingPaymentId") }}: </label
							>N/A
						</div>
						<div class="col-md-12 border-top mt-4"></div>
						<!-- Package Name -->
						<div class="col-md-4">
							<div class="row mt-5 ml-1">
								<label class="mr-5 align-self-center mb-0">
									<em class="bx bx-package font-size-16 align-middle mr-1"></em
									>{{ $t("booking.editBooking.bookingPackage") }}:
								</label>
								<b-form-select
									class="col-md-7"
									placeholder="Packages"
									:options="this.bookingPackages"
									v-model="this.selectedPackage"
									v-on:change="handlePackageSelect"
								/>
							</div>
						</div>
						<!-- Subpackage Name -->
						<div class="col-md-8">
							<div class="row mt-5 ml-1">
								<label class="mr-5 align-self-center mb-0">
									<em class="bx bxs-package font-size-16 align-middle mr-1"></em
									>{{ $t("booking.editBooking.bookingSubpackage") }}:
								</label>
								<b-form-select
									class="col-md-7"
									placeholder="Sub Packages"
									:options="this.bookingSubPackages"
									v-model="this.selectedSubPackage"
									v-on:change="handleSubPackageSelect"
								/>
							</div>
						</div>
						<!-- Number of Packs -->
						<div class="col-md-12">
							<div class="row mt-5">
								<label class="mr-3 align-self-center col-md-2">
									<em class="bx bx-group font-size-16 align-middle mr-1"></em
									>{{ $t("booking.editBooking.bbokingNumberOfPacks") }}:
								</label>
								<div>
									<b-form-input
										type="number"
										min="1"
										placeholder="Anzahl der Personen"
										validation="required"
										v-model="numOfPacks"
										class="col-md-12"
										:class="{ 'is-invalid': submitted && $v.numOfPacks.$error }"
										v-on:input="handleTotPriceChange"
									/>
									<div
										v-if="submitted && $v.numOfPacks.$error"
										class="invalid-feedback"
									>
										<span v-if="!$v.numOfPacks.required">{{
											$t("booking.editBooking.inputValidationMessage")
										}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Extras -->
					<div class="col-md-12 mt-5">
						<div class="row">
							<label class="mr-5 align-self-center mb-0">
								<em class="bx bx-extension font-size-16 align-middle mr-1"></em
								>{{ $t("booking.editBooking.bookingExtras") }}:
							</label>
							<div class="col-md-10 ju">
								<multiselect
									class="col-md-10"
									v-model="selectedExtras"
									:options="extras"
									:multiple="true"
									track-by="text"
									label="text"
									v-on:input="handleTotPriceChange"
								></multiselect>
							</div>
						</div>
					</div>
					<div class="col-md-12 border-top mt-4"></div>
					<div class="row">
						<!-- booking Name -->
						<div class="col-md-4 mt-4">
							<div class="row ml-1">
								<label class="mr-4 align-self-center mb-0">
									<em class="bx bx-user font-size-16 align-middle mr-1"></em>
									{{ $t("booking.editBooking.bookingReserverName") }}:
								</label>
								<div>
									<b-form-input
										type="text"
										placeholder="Name des Servers"
										validation="required"
										v-model="reserverName"
										class="col-md-12"
										:class="{
											'is-invalid': submitted && $v.reserverName.$error,
										}"
									/>
									<div
										v-if="submitted && $v.reserverName.$error"
										class="invalid-feedback"
									>
										<span v-if="!$v.reserverName.required">{{
											$t("booking.editBooking.inputValidationMessage")
										}}</span>
									</div>
								</div>
							</div>
						</div>
						<!-- booking Email -->
						<div class="col-md-4 mt-4">
							<div class="row ml-1">
								<label class="mr-4 align-self-center mb-0">
									<em class="bx bx-envelope font-size-16 align-middle mr-1"></em
									>{{ $t("booking.editBooking.bookingReserverEmail") }}:
								</label>
								<div>
									<b-form-input
										type="email"
										placeholder="E-Mail des Reservierers"
										validation="required"
										v-model="reserverEmail"
										class="col-md-12"
										:class="{
											'is-invalid': submitted && $v.reserverEmail.$error,
										}"
									/>
									<div
										v-if="submitted && $v.reserverEmail.$error"
										class="invalid-feedback"
									>
										<span v-if="!$v.reserverEmail.required">{{
											$t("booking.editBooking.inputValidationMessage")
										}}</span>
										<span v-if="!$v.reserverEmail.email">{{
											$t("booking.editBooking.invalidEmailError")
										}}</span>
									</div>
								</div>
							</div>
						</div>
						<!-- booking Telephone -->
						<div class="col-md-4 mt-4">
							<div class="row ml-1">
								<label class="mr-4 align-self-center mb-0">
									<em class="bx bx-phone font-size-16 align-middle mr-1"></em
									>{{ $t("booking.editBooking.bookingReserverTelephone") }}:
								</label>
								<div>
									<b-form-input
										type="tel"
										placeholder="Kontakt von Reserver"
										validation="required"
										v-model="reserverTelephone"
										class="col-md-12"
										:class="{
											'is-invalid': submitted && $v.reserverTelephone.$error,
										}"
									/>
									<div
										v-if="submitted && $v.reserverTelephone.$error"
										class="invalid-feedback"
									>
										<span v-if="!$v.reserverTelephone.required"
											>This value is required.</span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-12 border-top mt-4 mb-4"></div>
					<!-- booking Note -->
					<div class="row">
						<div class="col-md-8 mt-2">
							<label>
								<em class="bx bx-note font-size-16 align-middle mr-1"></em>
								{{ $t("booking.editBooking.bookingNote") }}:
							</label>
							<textarea
								v-model="bookingNote"
								class="form-control col-md-11"
								:maxlength="225"
								rows="3"
								placeholder="Geben Sie einen Buchungskommentar ein"
							></textarea>
						</div>
						<!-- Total Price -->
						<div class="col-md-2 mt-2">
							<label class="row">
								<em
									class="bx bx-calculator font-size-16 align-middle mr-1"
								></em>
								{{ $t("booking.editBooking.bookingTotalPrice") }}:
							</label>
							<span class="font-weight-bold row font-size-20">
								EUR {{ Math.trunc(this.totalPrice).toLocaleString("de") }},00
							</span>
						</div>
						<!-- Invoice Number -->
						<div class="col-md-2 mt-2">
							<label class="row">
								<em
									class="bx bx-calculator font-size-16 align-middle mr-1"
								></em>
								{{ $t("booking.editBooking.bookingInvoiceNumber") }}:
							</label>
							<span class="font-weight-bold row font-size-20">
								{{ this.bookingInvoiceNo }}
							</span>
						</div>
					</div>
					<!-- Action -->
					<div class="row mt-5">
						<div class="col-md-11 mt-3 ml-3">
							<b-button
								v-if="this.status === 'PENDING' && this.bookingValid"
								class="mr-5"
								variant="success"
								@click="clickConfirmBookingButton()"
							>
								<em class="bx bxs-check-circle mr-1"></em>
								{{ $t("booking.editBooking.bookingConfirmButton") }}</b-button
							>
							<b-button
								v-if="this.bookingValid"
								class="mr-5"
								variant="danger"
								v-b-modal.del-modal-center
							>
								<em class="bx bxs-trash mr-1"></em>
								{{ $t("general.buttons.delete") }}</b-button
							>
							<b-modal
								id="del-modal-center"
								ref="del-modal"
								centered
								:title="this.$i18n.t('booking.editBooking.deleteBookingTitle')"
								title-class="font-18"
								hide-footer
							>
								<p class="mb-4">
									{{ $t("booking.editBooking.deleteBookingDescription") }}
								</p>
								<b-button
									variant="danger"
									class="mr-4"
									@click="clickDeleteBookingButton()"
								>
									<em class="bx bxs-trash mr-1"></em
									>{{ $t("booking.editBooking.confirmDeleteButton") }}
								</b-button>
								<b-button
									variant="light"
									data-dismiss="modal"
									@click="$bvModal.hide('del-modal-center')"
								>
									<em class="bx bx-x mr-1" />{{ $t("general.buttons.cancel") }}
								</b-button>
							</b-modal>
							<b-button
								v-if="this.bookingPassed"
								class="mr-5"
								variant="danger"
								@click="clickDeleteBookingButton()"
							>
								<em class="bx bxs-trash mr-1"></em>
								{{ $t("general.buttons.delete") }}</b-button
							>
							<b-button variant="warning" class="mr-5" type="submit">
								<em class="bx bx-edit mr-1"></em>
								{{ $t("general.buttons.edit") }}</b-button
							>
							<b-button variant="light" @click="clickCloseButton()">
								<em class="bx bx-x mr-1"></em>
								{{ $t("general.buttons.cancel") }}</b-button
							>
						</div>
					</div>
				</form>
			</div>
		</div>
	</b-modal>
</template>
